import { createContext, useContext, useState } from "react";

const CardContext = createContext();

export const CardProvider = ({ children }) => {
    const [cardData, setCardData] = useState(null);

    function updateCardData(data) {
        console.log("CardContext update:", data);
        setCardData(data);
    }
    return (
        <CardContext.Provider value={{ cardData, updateCardData }}>
            {children}
        </CardContext.Provider>
    );
};

export const useCard = () => useContext(CardContext);
